import { PencilSquareIcon } from "@heroicons/react/24/outline";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import usePageIndex from "../../hooks/usePageIndex";
import { useSearch } from "../../hooks/useSearch";
import { ICustomReservationThreshold } from "../../interfaces/endpoints/ICustomReservationThreshold";
import {
  deleteThreshold,
  getAllThresholds
} from "../../services/CustomReservationThreshold.service";
import IconBtn from "../ui/IconBtn";
import Table, { Row } from "../ui/table";
import Pagination from "../ui/table/Pagination";
import DeleteThreshold from "./DeleteThresholdModal";
import {
  fromId,
  renderName,
  renderOperator,
  thresholdType,
  toId
} from "./thresholdCells";

const columns: (string | number)[] = [
  "Tipi",
  "Nisja",
  "Arritja",
  "Operatori",
  "Pragu (min)",
  "Veprimet"
];

const PAGE_SIZE = 10;

const ReservationThresholds = () => {
  // Paged: the table is thousands of rows after a country-wide change. Every row arrives with its
  // endpoints and its operator already named, so this screen makes one request, not one per id.
  const { response, loading, handlePageChange, page, setResponse } = useSearch(
    getAllThresholds,
    { withQuerySearch: true }
  );
  const { pageIndex } = usePageIndex();

  const handleDelete = (id: number) => {
    deleteThreshold(id)
      .then(() => {
        toast.success("Pragu u fshi me sukses.", { position: "top-right" });
        // Drop the row from the page in hand rather than refetching it.
        setResponse((prev) =>
          prev
            ? {
                ...prev,
                data: {
                  ...prev.data,
                  result: prev.data.result.filter(
                    (el: ICustomReservationThreshold) => el.id !== id
                  )
                }
              }
            : null
        );
      })
      .catch(() => toast.error("Ndodhi nje gabim gjate fshirjes."));
  };

  return (
    <div
      className="flex flex-col"
      style={{ height: "calc(100vh - 11rem)" }}
    >
      <Table
        titles={columns}
        loading={loading}
        className="overflow-x-auto"
        style="hover"
      >
        {response?.data?.result?.length ? (
          response.data.result.map(
            (row: ICustomReservationThreshold, i: number) => (
              <Row
                key={i}
                type={thresholdType(row)}
                from={renderName(row.fromDisplay, fromId(row))}
                to={renderName(row.toDisplay, toId(row))}
                operator={renderOperator(row)}
                threshold={
                  <span className="font-semibold">
                    {row.threshold} min
                  </span>
                }
                actions={
                  <span className="flex items-center">
                    <Link
                      to={`/reservation-thresholds/edit/${row.id}`}
                      state={{
                        crumbs: [
                          "Reservation Thresholds",
                          "Modifiko pragun"
                        ],
                        page: pageIndex,
                        thresholdData: row
                      }}
                    >
                      <IconBtn as="span" className="w-6 h-6">
                        <PencilSquareIcon className="w-4 h-4" />
                      </IconBtn>
                    </Link>
                    <DeleteThreshold
                      handleDelete={() => handleDelete(row.id)}
                    />
                  </span>
                }
              />
            )
          )
        ) : (
          <></>
        )}
      </Table>
      <Pagination
        onPageChange={handlePageChange}
        totalCount={response?.data?.totalCount || 0}
        length={response?.data?.result?.length}
        page={page}
        pageSize={PAGE_SIZE}
      />
    </div>
  );
};

export default ReservationThresholds;
